import React from 'react';
import { Button, Box, Typography, useMediaQuery } from '@mui/material';

import partAlt from '../assets/part.png';

const part = 'https://personaspace.fra1.cdn.digitaloceanspaces.com/landing/part-image.png';

const PartOfFun = () => {
  const isMobile = useMediaQuery('(max-width:439px)');
  const isTablet = useMediaQuery('(min-width:440px) and (max-width:1024px)');

  return (
    <Box
      sx={{
        maxWidth: '1920px',
        mx: 'auto',
        px: isMobile ? 1 : 6,
        pt: isMobile ? '80px' : '120px',
        pb: isMobile ? '60px' : '120px',
      }}
    >
      <Box textAlign="center" mb={6}>
        <Typography
          component="a"
          href="https://apps.apple.com/us/app/auratap/id6754709124"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: '#FF9F0A',
            fontFamily: 'Sora, sans-serif',
            fontWeight: 600,
            fontStyle: 'normal',
            fontSize: isMobile ? '12px' : '16px',
            lineHeight: '26px',
            letterSpacing: '15%',
            textAlign: 'center',
            textTransform: 'uppercase',
            textDecoration: 'none',
            cursor: 'pointer',
            mb: 2,
            '&:hover': {
              color: '#e69500',
            },
          }}
        >
          Get App Now
        </Typography>

        <Typography
          sx={{
            color: '#FFFFFF',
            fontFamily: 'Unbounded, sans-serif',
            fontWeight: 500,
            fontStyle: 'normal',
            fontSize: isMobile ? '33.6px' : isTablet ? '30.43px' : '50px',
            lineHeight: isMobile ? '130%' : '130%',
            letterSpacing: '0%',
            textAlign: 'center',
            px: isMobile ? 4 : 0,
            mt: 1,
            mb: 5,
          }}
        >
          Be part of tomorrows<br />fun, today.
        </Typography>

        <Typography
          sx={{
            color: '#FFFFFF',
            fontFamily: 'Sora, sans-serif',
            fontWeight: 400,
            fontStyle: 'normal',
            fontSize: isMobile ? '16px' : '16px',
            lineHeight: isMobile ? '26px' : '26px',
            letterSpacing: '0%',
            textAlign: 'center',
            px: isMobile ? 4 : 0,
            mx: 'auto',
            mb: isMobile ? 8 : 5,
          }}
        >
          We’re not live yet, but we’re working very hard to bring you this new social<br />experience as soon as possible. But you can sign up already and create<br />your AuraTap profile!
        </Typography>

        <Box sx={{ pt: isMobile ? '0px' : '60px', textAlign: 'center' }}>
          <Box
            component="img"
            src={isMobile ? partAlt : part}
            alt="Part"
            sx={{
              width: { xs: '95%', sm: '100%' },
              height: 'auto',
              maxWidth: '1200px',
              mx: 'auto',
            }}
          />
        </Box>

        <Button
          component="a"
          href="https://apps.apple.com/us/app/auratap/id6754709124"
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          size="large"
          sx={{
            mt: isMobile ? '45px' : '50px',
            height: isMobile ? '53.23px' : '61px',
            fontFamily: 'Sora, sans-serif',
            backgroundColor: '#30D158',
            color: '#FFFFFF',
            borderRadius: isMobile ? '43.44px' : '50px',
            boxShadow: 'none',
            textTransform: 'none',
            fontWeight: isMobile ? 700 : 600,
            fontStyle: 'normal',
            fontSize: isMobile ? '14.77px' : '17px',
            lineHeight: '100%',
            letterSpacing: '0em',
            px: isMobile ? '26.07px' : '30px',
            py: isMobile ? '19.11px' : '22px',
            transition: 'transform 0.3s ease, background-color 0.3s ease',

            '&:hover': {
              backgroundColor: '#30D158',
              boxShadow: 'none',
              transform: 'scale(1.05)',
            },
          }}
        >
          Get App Now
        </Button>
      </Box>
    </Box>
  );
};

export default PartOfFun;
